import React from "react"

import styles from "./Quote.module.scss"

const Quote = ({ html, citation, citationStyle = "regular" }) => {
  return html || citation !== "<p></p>" ? (
    <div className={styles.quote}>
      <blockquote dangerouslySetInnerHTML={{ __html: html }}></blockquote>
      {citation && citation !== "<p></p>" && (
        <div
          className={`${styles.citation} ${
            citationStyle === "bold" ? styles.bold : ""
          }`}
        >
          <cite>
            {citationStyle === "regular" && <>&ndash;</>} {citation}
          </cite>
        </div>
      )}
    </div>
  ) : null
}

export default Quote
